export default __webpack_public_path__ + "static/media/26a35234f5061ad9645dac6406dea244.svg";